<template>

  <div class="ob-grid">
    <v-card class="ob-col-3">
      <toolbar medium>
        <template v-slot:head>
          {{ $t('assets.variables') }}
        </template>
      </toolbar>

      <variables-list :options="variables" v-model="asset.enabledVariables" :readonly="readonly" @change="$emit('change', $event)" />
    </v-card>

    <v-card class="ob-col-3">
      <toolbar medium>
        <template v-slot:head>
          {{ $t('assets.commands') }}
        </template>
      </toolbar>

      <commands-list :options="commands" v-model="asset.enabledCommands" :readonly="readonly" />
    </v-card>

    <v-card class="ob-col-6">
      <toolbar medium>
        <template v-slot:head>
          {{ $t('assets.device-config') }}
        </template>
      </toolbar>

      <v-text-field v-for="(options, propertyName) in config" :key="propertyName" v-model="asset.deviceConfig[propertyName]" :label="$t(propertyName)"/>
      <no-data v-if="!Object.keys(config).length" medium>{{ $t('assets.no-device-config') }}</no-data>
    </v-card>
  </div>

</template>

<script>
  import VariablesList from './device-config/variables-list'
  import CommandsList from './device-config/commands-list'
  import Toolbar from '../../shared/toolbar'
  import NoData from "../../shared/no-data";

  export default {
    name: 'asset-device-config',

    props: [ 'asset', 'readonly' ],

    data () {
      return {
        type: {}
      }
    },

    computed: {
      deviceType () {
        return this.asset.deviceType
      },

      variables () {
        return this.type.variables ? Object.keys(this.type.variables) : []
      },

      commands () {
        return this.type.commands || []
      },

      config () {
        return this.type.deviceConfigOptions || {}
      }
    },

    methods: {
      async updateDeviceType () {
        const types = await this.$store.dispatch('getStaticItems', { model: { name: 'device-types' } })
        this.type = types.find(x => x.name === this.deviceType)
      }
    },

    watch: {
      async deviceType (value) {
        this.updateDeviceType()
      }
    },

    created () {
      this.updateDeviceType()
    },

    components: {
      NoData,
      CommandsList,
      Toolbar,
      VariablesList
    },
  }
</script>

<style scoped lang="scss">

</style>
